import * as React from "react";
import { Instagram, Facebook, Heart, MessageCircle, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const instagramPosts = [{
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409808/img/recycling_bins_residential.png",
  likes: 89,
  comments: 5,
  caption: "Did you know? Proper sorting helps us recycle more efficiently. Check our guide! "
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409808/img/fall_leaf_cleanup_bags.png",
  likes: 98,
  comments: 8,
  caption: "Seasonal cleanup made easy. Schedule your extra pickup today. "
}];
export default function InstagramFeed() {
  return <section id="instagramfeed" className="py-16 overflow-hidden !bg-[hsl(142,77%,73%)] md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-6 text-primary">
            <div className="flex items-center gap-2">
              <Instagram className="w-6 h-6" />
              <span className="text-sm font-semibold tracking-wider uppercase">@ColumbiaValleyWaste</span>
            </div>
            <div className="flex items-center gap-2">
              <Facebook className="w-6 h-6" />
              <span className="text-sm font-semibold tracking-wider uppercase">
                Columbia Valley Waste & Recycling
              </span>
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-sans text-primary mb-4 tracking-tight">Follow Us on Instagram &amp; Facebook</h2>
          
        </div>

        {}
        <div className="relative mx-auto max-w-7xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            
            
            {}
            <div className="hidden md:block">
              
              
            </div>
          </Carousel>
        </div>

        {}
        <div className="mt-12 text-center">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover rounded-full px-8 shadow-lg hover:shadow-xl transition-all duration-300">
            
          </Button>
        </div>
      </div>
    </section>;
}